<template>
    <form @submit.prevent="submitQuery" autocomplete="off">
        <b-row>
            <b-col xs="12">
                <b-form-group
                    class="mb-2"
                    label-for="headquarters"
                    label="<strong>Sede *</strong>">
                    <multiselect
                        id="headquarters"
                        v-model="query.headquarters"
                        :options="headquarters"
                        track-by="uuid"
                        label="name"
                        :multiple="false"
                        :allowEmpty="false"
                        placeholder="Seleccione opción"
                        selectLabel="+"
                        deselectLabel="-"
                        :disabled="!!limitForm"></multiselect>
                </b-form-group>
            </b-col>
        </b-row>

        <b-row class="px-3">
            <span v-if="differentHeadquarters" class="badge-warning text-white rounded p-1 mb-1">
                La sede seleccionada es diferente a la sede del usuario
            </span>
        </b-row>

        <b-row>
            <b-col xs="12" class="d-flex flex-row-reverse">
                <b-form-group>
                    <b-form-checkbox type="checkbox" v-model="query.urgent" :disabled="!!limitForm || query.status === 'REASSIGNED'">
                        URGENTE
                    </b-form-checkbox>
                </b-form-group>
            </b-col>
        </b-row>

        <b-row>
            <b-col xs="12">
                <b-form-group
                    label-for="description"
                    label="<strong>Descripción y motivo de la consulta *</strong>">
                    <b-form-textarea
                        id="description"
                        v-model="query.description"
                        :rows="6"
                        :max-rows="6">
                    </b-form-textarea>
                </b-form-group>
            </b-col>
        </b-row>

        <b-row>
            <b-col xs="12" class="d-flex flex-row-reverse">
                <b-form-group>
                    <b-form-checkbox type="checkbox" v-model="query.potentialMember" :disabled="!!limitForm">
                        Enviar a Captación Comercial
                    </b-form-checkbox>
                </b-form-group>
            </b-col>
        </b-row>

        <b-row>
            <b-col xs="12">
                <b-form-group
                    label-for="comment"
                    label="<strong>Comentarios</strong>">
                    <b-form-textarea
                        id="comment"
                        v-model="query.comment"
                        :rows="3"
                        :max-rows="3">
                    </b-form-textarea>
                </b-form-group>
            </b-col>
        </b-row>

        <b-row>
            <b-col xs="12" sm="6">
                <b-form-group
                    label="<strong>Fecha y hora *</strong>"
                    label-for="date"
                    class="w-100">
                    <vue2-date-picker
                        v-model="query.date"
                        type="datetime"
                        :format="`DD/MM/YYYY`"
                        :time-picker-options="timePickerOptions"
                        :lang="lang"
                        :editable="false"
                        :first-day-of-week="1"
                        :disabled="!!limitForm"
                        class="w-100 date-picker-w-100 date-picker-custom-border"></vue2-date-picker>
                </b-form-group>
            </b-col>
            <b-col xs="12" sm="6">
                <b-form-group
                    label-for="origin"
                    label="<strong>Origen *</strong>">
                    <multiselect
                        id="origin"
                        v-model="query.origin"
                        :options="queryOrigins.map(origin => origin.value)"
                        :custom-label="opt => queryOrigins.find(origin => origin.value === opt).text"
                        :multiple="false"
                        :allowEmpty="false"
                        placeholder="Seleccione opción"
                        selectLabel="+"
                        deselectLabel="-"
                        :disabled="!!limitForm"></multiselect>
                </b-form-group>
            </b-col>
        </b-row>

        <b-row>

            <b-col>

                <b-form-group
                    label-for="associatedProjects"
                    label="<strong>Proyectos Asociados</strong>">
                    <multiselect
                        id="associatedProjects"
                        v-model="query.associatedProjects"
                        :options="associatedProjects.map(project => project.uuid)"
                        :custom-label="opt => associatedProjects.find(project => project.uuid === opt).name"
                        :multiple="true"
                        :allowEmpty="true"
                        placeholder="Seleccione proyecto"
                        selectLabel="+"
                        deselectLabel="-"
                        :disabled="!!limitForm"></multiselect>
                </b-form-group>

            </b-col>

        </b-row>

        <b-row>
            <b-col xs="12">
                <b-form-group label="<strong>Tipo de Consulta *</strong>">

<!--                    <b-list-group v-if="!!initialQuery && !initialQuery.originQueryId">-->
<!--                        <b-list-group-item class="disabled">-->
<!--                            {{ initialQuery.category.name }} - {{ initialQuery.adviser.name }}-->
<!--                        </b-list-group-item>-->
<!--                    </b-list-group>-->

                    <category-adviser-selector  v-model="query.categoryAdvisers" class="px-3"></category-adviser-selector>

                </b-form-group>
            </b-col>
        </b-row>

    </form>
</template>

<script>
    import Multiselect from 'vue-multiselect';
    import Vue2DatePicker from 'vue2-datepicker';
    import {getQueryOriginsOptions} from '@/helpers/query-helper';
    import {getAssociatedProjects} from "@/api/associated-project-api";
    import CategoryAdviserSelector from "./Component/CategoryAdviserSelector";

    export default {
        name: "query-form",
        components: {
            CategoryAdviserSelector,
            Multiselect,
            Vue2DatePicker
        },
        props: [
            'emitSubmitEvent',
            'headquarters',
            'initialQuery',
            'limitForm',
            'clientHeadquarter'
        ],
        data: function () {
            return {
                query: {
                    category: !!this.initialQuery
                        ? this.initialQuery.category
                        : null,
                    adviser: !!this.initialQuery
                        ? this.initialQuery.adviser
                        : null,
                    headquarters: !!this.initialQuery
                        ? this.initialQuery.headquarters
                        : null,
                    urgent: !!this.initialQuery
                        ? this.initialQuery.urgent
                        : false,
                    potentialMember: !!this.initialQuery
                        ? this.initialQuery.potentialMember
                        : false,
                    description: !!this.initialQuery
                        ? this.initialQuery.description
                        : null,
                    comment: !!this.initialQuery
                        ? this.initialQuery.comment
                        : null,
                    origin: !!this.initialQuery
                        ? this.initialQuery.origin
                        : null,
                    date: !!this.initialQuery
                        ? this.initialQuery.date
                        : new Date(),
                    status: !!this.initialQuery
                        ? this.initialQuery.status
                        : new Date(),
                    associatedProjects: null,
                    categoryAdvisers: !!this.initialQuery
                        ? [{category: this.initialQuery.category, adviser: this.initialQuery.adviser}]
                        : [],
                },
                associatedProjects: [],
                filteredAdvisers: [],
                timePickerOptions: {
                    start: '00:00',
                    step: '00:05',
                    end: '23:55'
                },
                lang: {
                    days: ['D', 'L', 'M', 'X', 'J', 'V', 'S'],
                    months: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
                    pickers: ['next 7 days', 'next 30 days', 'previous 7 days', 'previous 30 days'],
                    placeholder: {
                        date: 'Seleccione fecha y hora'
                    }
                }
            };
        },
        computed: {
            queryOrigins() {
                return getQueryOriginsOptions();
            },
            differentHeadquarters() {
                return this.clientHeadquarter
                    && this.query.headquarters
                    && this.clientHeadquarter.uuid !== this.query.headquarters.uuid;
            }
        },
        mounted() {
            if (!!this.query.queryCategory) {
                this.filteredAdvisers = this.advisers.filter((adviser) => (adviser.specialty.uuid === this.query.queryCategory.parent))
            }
            if (this.query.status === 'REASSIGNED') {
                this.query.urgent = true;
            }
            if (
                this.query.status === 'REASSIGNED'
                ||
                this.query.status === 'REOPEN'
            ) {
                this.query.date = new Date();
            }
            getAssociatedProjects().then((associatedProjects) => {
                this.associatedProjects = associatedProjects;
                if (!!this.initialQuery){
                    this.query.associatedProjects = this.initialQuery.associatedProjects.map(project => project.uuid)
                }
            });
        },
        methods: {
            submitQuery() {
                this.$emit('submit-query-form', this.query);
            },
        },
        watch: {
            emitSubmitEvent: function (val) {
                if (val === true) {
                    this.submitQuery();
                }
            },
        }
    }
</script>
